import React from "react";

const HotelDetailRules = ({ hotel, isMobile = false }) => {
    // Use hotel data from DB where possible, sensible defaults otherwise
    const hotelName = hotel?.hotelName || "this property";
    const starRating = hotel?.starRating || 3;

    // Derive couple policy from hotel data — higher-rated hotels more likely to be open
    const couplePolicy = starRating >= 3
        ? "Unmarried couples are welcome with valid ID proof."
        : "Couple stays subject to hotel policy. Contact us before booking.";

    return (
        <div style={{ background: "#fff", borderRadius: "16px", padding: isMobile ? "14px" : "24px", boxShadow: "0 4px 15px rgba(0,0,0,0.04)", marginBottom: "25px", border: "1px solid #f5f5f5" }}>
            <h3 style={{ fontSize: isMobile ? "1.1rem" : "1.3rem", fontWeight: "900", marginBottom: "20px", color: "#1a1a1a", letterSpacing: "-0.5px" }}>Property Rules</h3>

            <div style={{ display: "flex", gap: isMobile ? "10px" : "25px", marginBottom: "20px", paddingBottom: "15px", borderBottom: "1px solid #f5f5f5", flexDirection: isMobile ? "column" : "row" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ fontSize: isMobile ? "0.8rem" : "0.85rem", color: "#777" }}>Check-in:</span>
                    <span style={{ fontSize: isMobile ? "0.8rem" : "0.85rem", fontWeight: "800", color: "#1a1a1a" }}>12:00 PM</span>
                </div>
                {!isMobile && <div style={{ width: "1px", height: "15px", background: "#eee" }}></div>}
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ fontSize: isMobile ? "0.8rem" : "0.85rem", color: "#777" }}>Check-out:</span>
                    <span style={{ fontSize: isMobile ? "0.8rem" : "0.85rem", fontWeight: "800", color: "#1a1a1a" }}>12:00 PM</span>
                </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: isMobile ? "16px" : "30px" }}>
                <div>
                    <div style={{
                        background: "linear-gradient(135deg, #fdf8ee 0%, #fff 100%)",
                        padding: "12px 15px",
                        borderRadius: "10px",
                        border: "1px solid #f9e8cc",
                        marginBottom: "15px",
                        display: "flex",
                        alignItems: "center",
                        gap: "12px"
                    }}>
                        <span style={{ fontSize: "1.1rem" }}>✨</span>
                        <div>
                            <div style={{ fontWeight: "800", fontSize: "0.85rem", color: "#856404" }}>Couple Policy</div>
                            <div style={{ fontSize: isMobile ? "0.75rem" : "0.8rem", color: "#666" }}>{couplePolicy}</div>
                        </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: "10px", color: "#555", fontSize: isMobile ? "0.8rem" : "0.85rem" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#EE2E24", marginTop: "6px", flexShrink: 0 }}></div>
                        <p style={{ margin: 0 }}>Primary guest must be at least 18 years of age with valid ID.</p>
                    </div>
                </div>

                <div>
                    <ul style={{ padding: 0, margin: 0, listStyle: "none", color: "#555", fontSize: isMobile ? "0.8rem" : "0.85rem", display: "flex", flexDirection: "column", gap: "10px" }}>
                        {[
                            "Passport, Aadhaar & DL accepted as ID proof",
                            "Local IDs are not allowed for couple stays",
                            "Pets and Smoking are not permitted",
                            "Visitors allowed only in common areas"
                        ].map((rule, idx) => (
                            <li key={idx} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                                <span style={{ color: "#EE2E24", fontWeight: "bold" }}>•</span>
                                <span>{rule}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px", flexDirection: isMobile ? "column" : "row" }}>
                <div style={{ display: "flex", gap: "10px", width: isMobile ? "100%" : "auto" }}>
                    {["GUEST PROFILE", "PET RULES"].map(b => (
                        <button key={b} style={{ padding: "6px 12px", borderRadius: "8px", border: "1.5px solid #eee", background: "#fff", fontWeight: "800", fontSize: isMobile ? "0.66rem" : "0.7rem", cursor: "pointer", color: "#666", letterSpacing: "0.5px", flex: isMobile ? 1 : "unset" }}>{b}</button>
                    ))}
                </div>
                <button style={{ background: "none", border: "none", color: "#EE2E24", fontWeight: "800", fontSize: isMobile ? "0.75rem" : "0.85rem", cursor: "pointer", textDecoration: "underline", alignSelf: isMobile ? "flex-start" : "auto", padding: 0 }}>ALL PROPERTY RULES</button>
            </div>
        </div>
    );
};

export default HotelDetailRules;
